import { Button } from '@mui/material';
import styled from 'styled-components';

export const SMuiButton = styled(Button)`
  && {
    display: flex;
    background-color: ${({theme}) => theme.palette.colors.blue200};
    min-width: 90px;
    :hover {
      background-color: ${({theme}) => theme.palette.colors.blue100};
      color: ${({theme}) => theme.palette.colors.white};
    }
  }
`;
